import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'react-tooltip';
// TODO: use useId instead when upgraded to React 18
import { nanoid } from 'nanoid';
import { LabelButton, TrevorIcon } from '@trevor/ui-components';

export type InsightErrorProps = {
  message: string;
};

const ErrorTooltip = styled(Tooltip).attrs({
  effect: 'solid',
  type: 'error',
})`
  max-width: 500px;
`;

export const InsightError: React.FC<InsightErrorProps> = ({ message }) => {
  const tooltipId = nanoid();
  return (
    <>
      <div data-tooltip-id={`error_${tooltipId}`}>
        <LabelButton
          icon={<TrevorIcon name="warning" $color="#666" />}
          disabled
        >
          error
        </LabelButton>
      </div>

      <ErrorTooltip id={`error_${tooltipId}`}>{message}</ErrorTooltip>
    </>
  );
};
